import { useEffect, useRef } from 'react';
import { emitter, EmitterEvent } from '../util/tracking';
import { buildCategoryViewPayload, buildSearchResultsViewPayload } from '../util/TrackingUtil';
/**
 * Emits a view tracking event once: CATEGORY_VIEW when there's category
 * context, or SEARCH_RESULTS_VIEW for a pure search page (no category context).
 */
export const useCategoryViewTracking = (categoryLevels, sourceId, searchQuery) => {
    const hasFired = useRef(false);
    useEffect(() => {
        if (hasFired.current)
            return;
        if (categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels.length) {
            hasFired.current = true;
            emitter.emit(EmitterEvent.CATEGORY_VIEW, buildCategoryViewPayload(categoryLevels, sourceId, searchQuery));
        }
        else if (searchQuery) {
            hasFired.current = true;
            emitter.emit(EmitterEvent.SEARCH_RESULTS_VIEW, buildSearchResultsViewPayload(sourceId, searchQuery));
        }
    }, [categoryLevels, sourceId, searchQuery]);
};
